import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import clsx from 'clsx';
import AutoSizer from "react-virtualized-auto-sizer";
import cx from "classnames";
// @mui/material components
import { withStyles } from "@mui/styles";
import Drawer from "@mui/material/Drawer";
import Paper from "@mui/material/Paper";
// core components
import SidebarStyle from "../Sidebar/SidebarStyle";
import { PublicOutlined, Search } from "@mui/icons-material";
import axios from "axios";
import { createTheme } from '@mui/material/styles';
import {
  makeStyles,
  ThemeProvider,
} from "@mui/styles";

import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { unstable_useTreeItem2 as useTreeItem2 } from '@mui/x-tree-view/useTreeItem2';
import {
  TreeItem2Content,
  TreeItem2IconContainer,
  TreeItem2GroupTransition,
  TreeItem2Label,
  TreeItem2Root,
} from '@mui/x-tree-view/TreeItem2';
import { TreeItem2Icon } from '@mui/x-tree-view/TreeItem2Icon';
import { TreeItem2Provider } from '@mui/x-tree-view/TreeItem2Provider';
import { useTreeViewApiRef } from '@mui/x-tree-view/hooks/useTreeViewApiRef';

import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import { FormControlLabel, Switch } from "@mui/material";
import AdvancedSearchContext from "../../context/AdvancedSearchContext";
import UserService from "../../services/UserService";
import { getArchitecture } from "../../services/ConfigServices";
import batimentArbre from "assets/img/tree/Batiment-arbre-15x15.png";
import communeArbre from "assets/img/tree/Commune-arbre-15x15.png";
import entiteArbre from "assets/img/tree/Entité-arbre-15x15.png";
import feuArbre from "assets/img/tree/Feu-arbre-15x27.png";
import groupeArbre from "assets/img/tree/Groupe-arbre-15x15.png";
import siteArbre from "assets/img/tree/Site-arbre-15x15.png";
import zoneArbre from "assets/img/tree/Zone-arbre-15x15.png";
import compteArbre from "assets/img/tree/Compte-arbre-15x15.png";
import OverflowTip from "./OverflowTip";
import 'assets/css/MenuEntites/MenuEntites.css'; // Tell webpack that Button.js uses these styles
import { styled } from '@mui/material/styles';
import SimpleSearch2 from "components/Search/SimpleSearch2";
import { useTheme } from "@mui/material";

function GroupeArbre() {
  return (
    <img src={groupeArbre} alt={"icone la terre"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function BatimentArbre() {
  return (
    <img src={batimentArbre} alt={"icone un batiment"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function CommuneArbre() {
  return (
    <img src={communeArbre} alt={"icone commune"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function EntiteArbre() {
  return (
    <img src={entiteArbre} alt={"icone entité"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function FeuArbre() {
  return (
    <img src={feuArbre} alt={"icone un feu tricolore"} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function SiteArbre() {
  return (
    <img src={siteArbre} alt={"icone un site "} style={{ margin: "2px 6px 2px 0" }} />
  );
}
function ZoneArbre() {
  return <img src={zoneArbre} alt={"icone zone "} style={{ margin: "2px 6px 2px 0" }} />;
}
function CompteArbre() {
  return (
    <img src={compteArbre} alt={"icone du compte"} style={{ margin: "2px 6px 2px 0" }} />
  );
}

function getTreeIcon(type, subtype) {
  let icon = CompteArbre;
  if (type == 0) {
    if (subtype == 0) icon = CommuneArbre;
    else if (subtype == 1) icon = EntiteArbre;
    else if (subtype == 2) icon = GroupeArbre;
    else icon = GroupeArbre;
  } else if (type == 1) {
    icon = SiteArbre;
  } else if (type == 2) {
    if (subtype == 0) icon = BatimentArbre;
    else if (subtype == 1) icon = FeuArbre;
    else icon = BatimentArbre;
  } else if (type == 3) {
    icon = ZoneArbre;
  } else if (type == 4) {
    icon = CompteArbre;
  }
  return icon;
}

class SidebarWrapper extends React.Component {
  sidebarWrapper = React.createRef();

  render() {
    const { className, user, headerLinks, dates, tree } = this.props;
    return (
      <div className={className} ref={this.sidebarWrapper}>
        {user}
        {headerLinks}
        {dates}
        {tree}
      </div>
    );
  }
}

const darkTheme = createTheme({
  palette: {
    type: "dark",
  },
});

const useTreeItemStyles = makeStyles(() => ({
  root: {
    // marginTop: "5px !important",
    color: "var(--tree-view-uneselected-color)",
    "&:hover > $content": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    "&:focus > $content, &$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
    "&$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
  },
  treeGrid: {
    padding: "0 15px 0 7px",
  },
  content: {
    color: "var(--tree-view-uneselected-color)",
    //borderTopRightRadius: '16px',
    //borderBottomRightRadius: '16px',
    paddingRight: '8px',
    paddingLeft: 0,
    fontWeight: 500,
    "$expanded > &": {
      fontWeight: 400,
    },
  },
  group: {
    marginLeft: "6px",
    //'& $content': {
    //    paddingLeft: '16px',
    //},
  },
  expanded: {},
  selected: {
    "&:focus > $content, &$selected > $content": {
      backgroundColor: "#636363",
      color: "#fafafa",
    },
    "&$selected > $content": {
      backgroundColor: "#91C73C",
      color: "#fafafa",
    },
  },
  label: {
    fontWeight: "bold",
    backgroundColor: "transparent !important",
    paddingLeft: "0px",
  },
  // labelRoot: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     padding: '0px 0px 0px 0px',
  // },
  // labelIcon: {
  //     marginRight: '6px',
  //     color: '#ffffff',
  //     fontSize: '1.1rem',
  //     width: '15px',
  //     height: '15px'
  // },
  // labelText: {
  //     fontWeight: 'normal',
  //     fontFamily: '"Source Sans Pro",sans-serif',
  //     flexGrow: 1,
  //     fontSize: '0.83rem',
  //     paddingTop: '4px'
  // },
  labelRoot: {
    //display: "-webkit-inline-box",
    display: "flex",
    alignItems: "center",
    padding: "0px 0px 0px 0px",
    maxWidth: "195px",
    minWidth: "0",
  },
  labelIcon: {
    marginRight: "6px",
    color: "#ffffff",
    fontSize: "1.1rem",
    width: "15px",
    height: "15px",
  },
  labelText: {
    fontWeight: "normal",
    fontFamily: '"Source Sans Pro",sans-serif',
    flexGrow: 1,
    fontSize: "0.83rem",
    paddingTop: "4px",
    whiteSpace: "nowrap",
    // maxWidth: "160px",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
  },
  labelTextInactive: {
    fontWeight: "normal",
    fontFamily: '"Source Sans Pro",sans-serif',
    flexGrow: 1,
    fontSize: "0.83rem",
    paddingTop: "4px",
    whiteSpace: "nowrap",
    fontStyle: "italic",
    // maxWidth: "160px",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
  }
}));


const useStyles = makeStyles({
  root: {
    overflow: "hidden",
    height: "calc(100vh - 110px)",
    maxWidth: 254,
    marginTop: "5px !important",
    flexGrow: 1,
    "&:hover": {
      overflow: "auto",
    },
  },
  rootmultiple: {
    overflow: "hidden",
    height: "calc(100vh - 148px)",
    maxWidth: 254,
    marginTop: "5px !important",
    flexGrow: 1,
    "&:hover": {
      overflow: "auto",
    },
  },
  treeGrid: {
    padding: "0 15px 0 7px",
  }
});

const StyledFormControlLabel = withStyles({
  label: {
    color: "#FFFFFF",
    fontSize: "0.83rem",
    "&disabled": {
      color: "#AAAAAA",
    },
  },
})(FormControlLabel);

//switch
const StyledSwitch = withStyles({
  switchBase: {
    color: "#91C73C",
    "&$checked": {
      color: "#91C73C",
    },
    "&$checked + $track": {
      backgroundColor: "#FFFFFF",
    },
  },
  checked: {},
  track: {},
})(Switch);


export default function MenuEntites(props) {
  const apiRef = useTreeViewApiRef();
  const theme = useTheme();

  console.log('theme.breakpoints.up("sm")',theme.breakpoints.up("sm"))

  const useStyles2 = makeStyles(SidebarStyle(theme));
  const classes = useStyles();
  const classes2 = useStyles2();
  const classesTreeItem = useTreeItemStyles();
  const { handleGroupChange, ids, open, handleDrawerToggle, bgColor } = props;
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setChartIdGroup, setSelectedNodesInfo, page,
    treemustrefresh, groupchanged, selectedNodesInfo, outofcontextclic,
    setOutofcontextclic, resIds, setGroupInfoListById, setGroupTypeListById,
    groupInfoListById, setArchitecture, setGroupchanged, setTreemustrefresh, setEmbeddedtreerefresh, setGroupAccountListById } = appContext;

  const [openAvatar, setOpenAvatar] = useState(false);
  const [miniActive, setMiniActive] = useState(false);
  const [selectDate, setSelectDate] = useState("1");
  const [simpleSearch, setSimpleSearch] = useState("");
  const [architecture, setArchitecturestate] = useState([]);
  const [treeView, setTreeView] = useState([]);
  const [newTree, setNewTree] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [expanded, setExpanded] = useState([]);
  const [tmpExpanded, setTmpExpanded] = useState([]);

  const [onSelectIds, setOnSelectIds] = useState([]);

  const [firstSelectedId, setFirstSelectedId] = useState(false);
  const [multipleauthorized, setMultipleauthorized] = useState(false);

  const [inactivehidden, setInactivehidden] = useState(false);
  const [previousinactivehidden, setPreviousinactivehidden] = useState(false);

  const [firstelementsearchedfound, setFirstelementsearchedfound] = useState(false);

  const [isMultiple, setIsMultiple] = useState(false);
  const [previousisMultiple, setPreviousisMultiple] = useState(false);

  const [searchedItems, setSearchedItems] = useState([]);
  const [groupInfoList, setGroupInfoList] = useState({});
  const [groupTypeList, setGroupTypeList] = useState({});
  const [groupAccountList, setGroupAccountList] = useState({});

  const [searchedIds, setSearchedIds] = useState([]);
  const [searchresultindex, setSearchresultindex] = useState(0);

  // this.handleSearch = this.handleSearch.bind(this);
  // this.handleCancelSearch = this.handleCancelSearch.bind(this);
  // this.handleSwitchToMultipleSelect = this.handleSwitchToMultipleSelect.bind(this);
  // this.handleSwitchInactiveHidden = this.handleSwitchInactiveHidden.bind(this);


  let mainPanel = React.createRef();

  useEffect(() => {
    getArchitectureFunction();
  }, []);


  useEffect(() => {
    if (previousinactivehidden !== inactivehidden) {
      let newtreeview = getTreeView(architecture);
      setTreeView(newtreeview);
    }
    setPreviousinactivehidden(inactivehidden);
  }, [inactivehidden]);

  useEffect(() => {
    if (previousisMultiple && !isMultiple) {
      let newselection = [];
      if (Array.isArray(onSelectIds))
        newselection.push(onSelectIds[0])
      else
        newselection.push(onSelectIds)
      setOnSelectIds(newselection);
      setChartIdGroup(newselection);
      setSelectedNodesInfo(groupInfoListById["" + newselection]);
    }
    setPreviousisMultiple(isMultiple);
  }, [isMultiple]);

  useEffect(() => {
    if (page === 'maps' || page === 'analyse') {
      setMultipleauthorized(true);
    }
    else {
      if (isMultiple) {
        let newselection = [];
        if (Array.isArray(onSelectIds))
          newselection.push(onSelectIds[0])
        else
          newselection.push(onSelectIds)
        setOnSelectIds(newselection);
        setChartIdGroup(newselection);
        setSelectedNodesInfo(groupInfoListById["" + newselection]);
      }
      setMultipleauthorized(false);
    }
  }, [page]);

  useEffect(() => {
    if (treemustrefresh) {
      let prevSelected = [...onSelectIds];
      let prevExpanded = [...expanded];
      if (groupchanged) {
        if (!prevExpanded.includes(prevSelected))
          //push father to prevexpanded
          prevExpanded.push(prevSelected);
        prevSelected = groupchanged;
        setGroupchanged("");
      }
      let prevSelectedNodesInfo = selectedNodesInfo;
      setTreemustrefresh(false);
      getArchitectureFunction(prevExpanded, prevSelected, prevSelectedNodesInfo);

    }
  }, [treemustrefresh]);

  useEffect(() => {
    if (outofcontextclic) {
      setOnSelectIds(outofcontextclic);
      const expandedtmp = [];
      defineExpanded(architecture, outofcontextclic, expandedtmp);
      setExpanded(expandedtmp);
      setOutofcontextclic("");
      handleGroupChange();
    }
  }, [outofcontextclic]);

  useEffect(() => {
    if (searchedIds.length > 0) {
      setTmpExpanded([...expanded]);
      let expandednodes = [];
      expandSearch(treeView, expandednodes);
      setExpanded(expandednodes);
    }
    else {
      setExpanded([...tmpExpanded]);
      freeSearch(treeView);
    }
  }, [JSON.stringify(searchedIds)]);

  const expandSearch = (treenode, expandednodes) => {
    let expandfather = false;
    treenode.forEach((item) => {
      let expanded = false;
      if (searchedIds.includes(item.id)) {
        expanded = true;
        item.searched = true;
      }
      else
        item.searched = false;
      let expandedbychildren = false;
      if (item.children && item.children.length > 0)
        expandedbychildren = expandSearch(item.children, expandednodes);
      if (expandedbychildren)
        expandednodes.push(item.id);
      if (expanded || expandedbychildren)
        expandfather = true;
    });
    return expandfather;
  }

  const freeSearch = (treenode) => {
    treenode.forEach((item) => {
      item.searched = false;
      if (item.children && item.children.length > 0)
        freeSearch(item.children);
    });
  }

  const getArchitectureFunction = (prevExpanded, prevSelected, prevSelectedNodesInfo) => {
    axios
      .get(getArchitecture(), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        const architecturetmp = response.data.architecture;
        let firstSelectedId;
        let firstSelectedText = "";
        let hasGroups = false;
        if (response.data.architecture[0]) {
          firstSelectedId = response.data.architecture[0].id;
          firstSelectedText = response.data.architecture[0].text;
          hasGroups = true;
        }
        setArchitecturestate(architecturetmp);
        setGroupInfoList({});
        setGroupTypeList({});
        setGroupAccountList({})
        let treeviewtmp = getTreeView(architecturetmp);
        setTreeView(treeviewtmp);
        setIsFiltered(false);
        let expandedtmp = hasGroups ? prevExpanded ? prevExpanded : ["0", firstSelectedId] : ["0"];
        setExpanded(expandedtmp);
        setOnSelectIds(prevSelected ? prevSelected : firstSelectedId);
        setFirstSelectedId(true);

        setGroupInfoListById(groupInfoList);
        setGroupTypeListById(groupTypeList);
        setGroupAccountListById(groupAccountList)
        setChartIdGroup([prevSelected ? prevSelected : firstSelectedId]);
        setSelectedNodesInfo(prevSelectedNodesInfo ? prevSelectedNodesInfo : firstSelectedText);
        setArchitecture(architecturetmp);
        setEmbeddedtreerefresh(true);
      })
      .catch((error) => {
        if (error.response) {
          console.error("ERROR", error.message);
        } else if (error.request) {
          console.error("request error", error.request);
          UserService.getLogout();
        }
      });
  }

  const getTreeView = (archiData) => {
    return archiData.map((archiElement) => {
      groupInfoList["" + archiElement.id] = archiElement.text;
      groupTypeList["" + archiElement.id] = archiElement.type + "." + (archiElement.subtype || '0');
      groupAccountList["" + archiElement.id] = archiElement.accountid;

      let leaf = {};
      leaf.label = archiElement.text;
      leaf.id = "" + archiElement.id;
      leaf.avobid = archiElement.id;
      leaf.inactive = archiElement.r;
      leaf.labelIcon = getTreeIcon(archiElement.type, archiElement.subtype);
      if (archiElement.children && archiElement.children.length > 0) {
        let leafchilds = getTreeView(archiElement.children);
        if (leafchilds.length > 0)
          leaf.children = leafchilds;
      }
      return leaf;
    });
  }


  const defineExpanded = (architecture, ids, expandednodes) => {
    let expandfather = false;
    architecture.forEach((item) => {
      let expanded = false;
      if (ids.includes(item.id)) {
        expanded = true;
      }
      let expandedbychildren = false;
      if (item.children && item.children.length > 0)
        expandedbychildren = defineExpanded(item.children, ids, expandednodes);
      if (expandedbychildren)
        expandednodes.push(item.id);
      if (expanded || expandedbychildren)
        expandfather = true;
    });
    return expandfather;


    // let inIds = false;
    // architecture.forEach((element) => {
    //   let childInIds;
    //   childInIds = defineExpanded(element.children, ids);
    //   if (childInIds) {
    //     expanded.push(element.id);
    //     inIds = true;
    //   }
    //   if (ids.indexOf(element.id) > -1) {
    //     inIds = true;
    //   }
    // });
    // return inIds;
  }

  const scrollup = (event) => {
    if (searchresultindex > 1) {
      let newindex = searchresultindex - 1;
      let id = searchedIds.at(newindex - 1);
      let current = apiRef.current;
      if (current)
        current.focusItem(event, '' + id);
      setSearchresultindex(newindex);
    }
  }

  const scrolldown = (event) => {
    if (searchresultindex < searchedIds.length) {
      let newindex = searchresultindex + 1;
      let id = searchedIds.at(newindex - 1);
      let current = apiRef.current;
      if (current)
        current.focusItem(event, '' + id);
      setSearchresultindex(newindex);
    }
  }

  const handleAdvancedTree = () => {
    const selectIds = resIds;
    const newNodeIds = [].concat([...selectIds]);
    const expandedtmp = [];
    defineExpanded(architecture, selectIds, expandedtmp);
    setExpanded(expandedtmp);
    setIsMultiple(true);
    setOnSelectIds(newNodeIds);
    setChartIdGroup(newNodeIds);
    if (newNodeIds.length > 1) {
      setSelectedNodesInfo(newNodeIds.length + " entités sélectionnées");
    } else {
      setSelectedNodesInfo(newNodeIds.length + " entité sélectionnée");
    }
  };

  const handleSwitchToMultipleSelect = (event) => {
    setIsMultiple(event.target.checked);
  }
  const handleSwitchInactiveHidden = (event) => {
    setInactivehidden(event.target.checked);
  }


  const StyledTreeItemRoot = styled(TreeItem2Root)(({ theme }) => ({
    // marginTop: "5px !important",
    paddingTop: 4,
    [`& .MuiCollapse-root`]: {
      paddingLeft: 5,
      marginLeft: 0,
    },
    color: "var(--tree-view-uneselected-color)",
    "&:hover > $content": {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    "&:focus > $content, &$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
    "&$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
  }));
  const CustomTreeItemContent = styled(TreeItem2Content)(({ theme }) => ({
    color: "var(--tree-view-uneselected-color)",
    paddingRight: '8px',
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    columnGap: 3,
    fontWeight: 500,
    "$expanded > &": {
      fontWeight: 400,
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
    [`&.AVOB-searched`]: {
      color: "#91c241"
    },
    [`&.Mui-selected`]: {
      backgroundColor: "#91C73C",
      color: "#FFFFFF"
    }
  }));




  const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
    const { id, itemId, label, disabled, children, ...other } = props;
    const {
      getRootProps,
      getContentProps,
      getIconContainerProps,
      getLabelProps,
      getGroupTransitionProps,
      status,
      publicAPI,
    } = useTreeItem2({ id, itemId, children, label, disabled, rootRef: ref });

    let item = publicAPI.getItem(itemId);
    let LabelIcon = item.labelIcon;
    if (item.inactive && inactivehidden)
      return;
    return (
      <TreeItem2Provider itemId={itemId}>
        <StyledTreeItemRoot {...getRootProps(other)}>
          <CustomTreeItemContent {...getContentProps({
            className: clsx('content', {
              'Mui-expanded': status.expanded,
              'Mui-selected': status.selected,
              'Mui-focused': status.focused,
              'Mui-disabled': status.disabled,
              'AVOB-searched': item.searched,
            }),
          })}>
            <TreeItem2IconContainer {...getIconContainerProps()} className="avobtreeicon">
              <TreeItem2Icon status={status} />
            </TreeItem2IconContainer>
            <div className={classesTreeItem.labelRoot}>
              <LabelIcon color="inherit" className={classesTreeItem.labelIcon} />
              <Typography variant="body2" className={item.inactive ? classesTreeItem.labelTextInactive : classesTreeItem.labelText}>
                <OverflowTip value={label} someLongText={label} />
              </Typography>
            </div>
          </CustomTreeItemContent>
          {children && (
            <TreeItem2GroupTransition {...getGroupTransitionProps()} />
          )}
        </StyledTreeItemRoot>
      </TreeItem2Provider >
    );
  });


  const createTree = () => {
    return (
      <div>
        <GridContainer>
          <GridItem>
            <SimpleSearch2
              setSearchedIds={setSearchedIds}
              searchedIds={searchedIds}
              handleAdvanceTree={() => handleAdvancedTree()}
              searchresultindex={searchresultindex}
              setSearchresultindex={setSearchresultindex}
              scrollup={scrollup}
              scrolldown={scrolldown}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem>
            <StyledFormControlLabel
              control={
                <StyledSwitch
                  checked={inactivehidden}
                  color={'secondary'}
                  name={'inactivehiddenCheck'}
                  onChange={handleSwitchInactiveHidden}
                  inputProps={{
                    'aria-label': 'multiple select switch'
                  }}
                />
              }
              label={'Cacher les éléments inactifs'}
            />
          </GridItem>
          <GridItem>
            {
              multipleauthorized ?
                <StyledFormControlLabel
                  control={
                    <StyledSwitch
                      checked={isMultiple}
                      color={'secondary'}
                      name={'multipleCheckSw'}
                      onChange={handleSwitchToMultipleSelect}
                      inputProps={{
                        'aria-label': 'multiple select switch'
                      }}
                    />
                  }
                  label={'Sélection multiple'}
                /> : <></>
            }
          </GridItem>
          <GridItem
            className={"treeGrid"}
            style={{
              borderTop: "1px solid #868686"
            }}
          >
            <ThemeProvider theme={darkTheme}>
              <AdvancedSearchContext.Consumer>
                {({ setChartIdGroup, setSelectedNodesInfo, groupInfoListById }) => {
                  return (
                    <AutoSizer
                      style={{
                        width: "250px",
                        // height: `calc(100vh - 103px)`,
                        height: multipleauthorized ? `calc(100vh - 144px)` : `calc(100vh - 106px)`,
                      }}
                    >
                      {(size) => (
                        <RichTreeView
                          apiRef={apiRef}
                          className={multipleauthorized ? classes.rootmultiple : classes.root}
                          items={isFiltered === true ? newTree : treeView}
                          expandedItems={expanded}
                          slots={{
                            item: CustomTreeItem,
                            expandIcon: ArrowRightIcon,
                            collapseIcon: ArrowDropDownIcon,
                            parentIcon: PublicOutlined
                          }}
                          onExpandedItemsChange={(event, itemIds) => {
                            event.persist();
                            const iconClicked = event.target
                              .closest('div')
                              .matches('[class*="avobtreeicon"]');
                            if (iconClicked) {
                              setExpanded(itemIds);
                            }
                          }}
                          multiSelect={isMultiple && multipleauthorized}
                          onSelectedItemsChange={(event, ids) => {
                            event.persist();
                            const iconClicked = event.target
                              .closest('div')
                              .matches('[class*="avobtreeicon"]');
                            if (!iconClicked) {
                              setOnSelectIds(ids);
                              setFirstSelectedId(false);

                              let idgroup = [ids];
                              setChartIdGroup(idgroup);

                              if (idgroup.length > 1) {
                                setSelectedNodesInfo(
                                  idgroup.length + " entités sélectionnées"
                                );
                              } else if (idgroup.length == 1) {
                                setSelectedNodesInfo(groupInfoListById["" + idgroup[0]]);
                              }
                            }
                          }}
                          selectedItems={onSelectIds}
                        >
                        </RichTreeView>
                      )}
                    </AutoSizer>
                  );
                }}
              </AdvancedSearchContext.Consumer>
            </ThemeProvider>
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  const drawerPaper =
    classes2.drawerPaperMenuEntites +
    " " +
    classes2.drawerPaperRight +
    " " +
    cx({
      [classes2.drawerPaperMiniFilters]:
        miniActive
    });

  const sidebarWrapper =
    classes2.sidebarWrapperMenuEntites +
    " " +
    cx({
      [classes2.drawerPaperMiniFilters]:
        miniActive,
      [classes2.sidebarWrapperWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
      [classes2.hideWrapper]: miniActive,
    });

  return (
    <div ref={mainPanel}>
      {/* <Hidden mdUp implementation="css"> */}
      <Paper sx={{ display: { md: 'none' } }} >
        <Drawer
          variant="temporary"
          anchor="left"
          open={open}
          classes={{
            paper: drawerPaper + " " + classes2[bgColor + "Background"],
          }}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <Search />
          <SidebarWrapper className={sidebarWrapper} />
        </Drawer>
      </Paper>
      {/* <Hidden smDown implementation="css"> */}
      <Paper sx={{ display: { sm: 'block' } }} >
        <Drawer
          anchor="left"
          variant="permanent"
          open
          classes={{
            paper: drawerPaper + " " + classes2[bgColor + "Background"],
          }}
        >
          <SidebarWrapper
            className={sidebarWrapper}
            tree={createTree()}
          />
        </Drawer>
      </Paper>
    </div>
  );



}


MenuEntites.defaultProps = {
  bgColor: "blue",
  ids: [],
};

MenuEntites.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose",
  ]),
  logo: PropTypes.string,
  icon: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  miniActive: PropTypes.bool,
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  handleSelectDateChange: PropTypes.func,
  handleDpDateBeginChange: PropTypes.func,
  handleDpDateEndChange: PropTypes.func,
  handleCheckedAChange: PropTypes.func,
  handleGroupChange: PropTypes.func,
  //handleAdvancedSearch: PropTypes.func,
  ids: PropTypes.arrayOf(PropTypes.string),
  architecture: PropTypes.arrayOf(PropTypes.object),
};

SidebarWrapper.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  headerLinks: PropTypes.object,
  dates: PropTypes.object,
  tree: PropTypes.object,
};
